import React from "react";
import { MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "966538278484";
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  "السلام عليكم، أحتاج إلى مساعدة بخصوص خدمات منصة أوتادك."
)}`;

const WhatsAppFab = () => {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="تواصل عبر الواتساب"
      className="fixed bottom-6 left-6 z-50 group"
    >
      <span className="absolute -top-9 start-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-[#222222] text-white text-xs px-3 py-1.5 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        للتواصل مع خدمة العملاء
      </span>
      <span className="flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1ebe5b] shadow-lg shadow-emerald-900/20 text-white transition-transform hover:scale-105 active:scale-95">
        <MessageCircle className="w-6 h-6" />
      </span>
    </a>
  );
};

export default WhatsAppFab;
